import { defineComponent as _defineComponent } from 'vue'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from '@@/library/v4/components/OzContainedButton.vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import type { OzMenuRowsRow } from '@@/library/v4/components/OzMenuRows.vue'
import OzMenuRows, { OzMenuRowsFocusStyle, OzMenuRowsRowStyle } from '@@/library/v4/components/OzMenuRows.vue'
import OzPlainButton, { OzPlainButtonSizePreset } from '@@/library/v4/components/OzPlainButton.vue'
import type { PopoverAnchor } from '@@/library/v4/components/OzPopoverModal.vue'
import OzScreenSizeAwareCenterModal from '@@/library/v4/components/OzScreenSizeAwareCenterModal.vue'
import OzScreenSizeAwarePopoverModal from '@@/library/v4/components/OzScreenSizeAwarePopoverModal.vue'
import { useWindowSizeStore } from '@@/pinia/window_size'
import type { Folder, FolderId, WallId } from '@@/types'
import { computed, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BookmarksModal',
  props: {
    wallId: null,
    folders: null,
    bookmarkedFolderIds: null,
    isFavorite: { type: Boolean },
    darkMode: { type: [Boolean, String], default: 'auto' },
    popoverAnchor: { default: null }
  },
  emits: ["remove-bookmark", "add-bookmark", "error", "new-folder", "close"],
  setup(__props: any, { emit }: { emit: ({
  (name: 'remove-bookmark', payload: { wallId: WallId; folderId?: FolderId }): void
  (name: 'add-bookmark', payload: { wallId: WallId; folderId?: FolderId }): void
  (name: 'error', error: any): void
  (name: 'new-folder', event: Event): void
  (name: 'close', event: Event): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { wallId: WallId, folders: Folder[], bookmarkedFolderIds: FolderId[], isFavorite: boolean, darkMode: true | false | 'auto', popoverAnchor: PopoverAnchor | null }





const windowSizeStore = useWindowSizeStore()

const isTitleFrozen = ref(false)
const isBookmarkedInitially = ref(false)

const folderRows = computed((): OzMenuRowsRow[] => {
  return props.folders.map((folder: Folder, index: number) => ({
    text: folder.name,
    rightIcon: isWallInFolder(folder) ? 'checkmark_thicker' : null,
    rightIconSize: 20,
    rightIconHighlighted: true,
    eventPayload: folder,
    testId: `selectBookmark${index}`,
    ariaChecked: String(isWallInFolder(folder)),
    icon: folder.icon || 'folder_outline',
  }))
})

const folderIdSet = computed((): Set<FolderId> => {
  return new Set(props.bookmarkedFolderIds)
})

const isBookmarked = computed((): boolean => {
  return props.isFavorite || props.bookmarkedFolderIds.length > 0
})

watch(
  isBookmarked,
  (value) => {
    if (!isTitleFrozen.value) isBookmarkedInitially.value = value
  },
  { immediate: true },
)

function isWallInFolder(folder): boolean {
  return folderIdSet.value.has(folder.id)
}

function toggleFavoritesBookmark(): void {
  isTitleFrozen.value = true
  const options = { wallId: props.wallId }
  try {
    if (props.isFavorite) {
      emit('remove-bookmark', options)
    } else {
      emit('add-bookmark', options)
    }
  } catch (e) {
    emit('error', e)
  }
}

function toggleFolderBookmark(folder: Folder): void {
  isTitleFrozen.value = true
  const options = { wallId: props.wallId, folderId: folder.id }
  try {
    if (isWallInFolder(folder)) {
      emit('remove-bookmark', options)
    } else {
      emit('add-bookmark', options)
    }
  } catch (e) {
    emit('error', e)
  }
}

function clearAllBookmarks(): void {
  isTitleFrozen.value = true
  const wallId = props.wallId
  try {
    if (props.isFavorite) emit('remove-bookmark', { wallId })
    props.folders.forEach((folder: Folder) => {
      if (isWallInFolder(folder)) emit('remove-bookmark', { wallId, folderId: folder.id })
    })
  } catch (e) {
    emit('error', e)
  }
}

function newFolder(event): void {
  isTitleFrozen.value = true
  emit('new-folder', event)
}

function close(event): void {
  emit('close', event)
}

return { __sfc: true,props, emit, windowSizeStore, isTitleFrozen, isBookmarkedInitially, folderRows, folderIdSet, isBookmarked, isWallInFolder, toggleFavoritesBookmark, toggleFolderBookmark, clearAllBookmarks, newFolder, close, OzContainedButton, OzContainedButtonColorScheme, OzContainedButtonSizePreset, OzIcon, OzMenuRows, OzMenuRowsFocusStyle, OzMenuRowsRowStyle, OzPlainButton, OzPlainButtonSizePreset, OzScreenSizeAwareCenterModal, OzScreenSizeAwarePopoverModal }
}

})